import random from './random';
export * from './random';
export default random;
//# sourceMappingURL=index.esm.js.map